// ══════════════════════════════════════════════════════════════════
//  보스 상태기계 — **골격.** 정본은 명세 6-2 + 30밤시트 N28·N29·N30 카드다.
//
//  ■ 지금 이 파일은 **아무 데도 안 붙어 있다.** world.js 가 잠겨 있어서다.
//    붙일 때 필요한 것은 세 줄뿐이게 만들어 뒀다:
//        this.boss = makeBoss('bear', { rnd: this.rnd, onCue });
//        this.boss.step(dt, { px, py });                 // moveEnemies 옆
//        mult = this.boss.damageMult(p.x, p.y);          // autoWeapon 안
//    Phaser·world 를 import 하지 않는다 — 헤드리스에서도 그대로 돈다.
//
//  ■ **【사장님 결정 2026-07-28】 보스는 시간이 함께 쓰러뜨린다 — 페이즈 HP.**
//    *"보스는 페이즈 별로 피가 깎이고, 마지막까지 살면 자연스럽게 죽는걸로.
//      게임 내내 피해다녀야 되는거야."*
//
//    이 결정이 **「HP 측정 대기」를 설계로 닫는다.** 지금까지 HP를 못 정한 이유는
//    *"플레이어 DPS로 역산해야 하는데 그 DPS가 안 정해졌다"* 였다. 이제 역산할
//    것이 없다 — **살아남으면 반드시 쓰러지므로 HP가 클리어 가능성을 좌우하지 않는다.**
//    HP는 「얼마나 빨리 끝낼 수 있는가」만 정하고, 그것은 밸런스지 소프트락이 아니다.
//
//    ■ 두 시계가 같은 HP를 깎는다 (둘 다 있어야 결정의 두 문장이 다 산다)
//        ① **페이즈 시계** — 밤을 PHASES 등분하고, 경계마다 최대 HP의 일정 비율이
//           떨어진다. *"페이즈 별로 피가 깎이고"* · *"마지막까지 살면 자연스럽게 죽는다"*
//        ② **플레이어 피해** — 급소를 잡으면 그 페이즈가 빨리 끝난다. 회피 게임에서도
//           **잘한 것이 보상돼야** 한다. 다만 아래 FLOOR 때문에 밤을 통째로 건너뛸 수는
//           없다 — *"게임 내내 피해다녀야 되는거야"* 가 그 하한이다.
//
//    ■ 서사 — 다윗은 사자와 곰을 **쳐죽였다**(삼상 17:35-36). 그것이 골리앗 앞에 설
//      근거였다. "시간이 다 돼서 죽었다"면 그 근거가 약해진다. 그래서 페이즈 감소를
//      **「버틸수록 약해진다」**로 읽는다 — 지치게 만들어서 쓰러뜨린 것이다.
//      마지막 순간의 연출은 「시간 종료」가 아니라 **「무릎을 꿇는다」**여야 한다.
//
//    ■ ⚠ **명세 6-2 와 충돌한다.** v1.5가 *"셋 다 격퇴 가능 보스가 됐다"*로 재설계한
//      조항을 이 결정이 뒤집는다. 조용히 바뀌면 안 되므로 여기에 적어 둔다.
//      `win` 이 전부 `'survive'` 가 되는 것이 그 변경의 코드 쪽 얼굴이다.
//
//  ■ 시간 값은 **정본에 있다**(지어낸 것이 아니다):
//      예고 1.5초(앞발로 땅 긁기 = 회피 신호, 사운드 큐 14)
//      → 돌진 12유닛 / 0.8초  → **정지 2초 = 급소 창**  → 배회 4~6초  → 반복
//      사이클 약 9초 (배회 4.7초일 때 정확히 9.0)
//    급소 = **배후에서 소년 무기 ×3.** *"급소는 조준이 아니라 위치다."*
//
//  ■ **물량층 스폰 −40% · 외곽 배회 정지는 연출이 아니라 해법의 성립 조건이다**
//    (30밤시트 429·448·462행). 배후를 잡으려면(곰) / 계속 도망 다니려면(사자)
//    **이동할 공간이 있어야 한다.** 그래서 이 값은 보스 파라미터가 아니라
//    스폰 규칙이며, 아래 `BOSS_SWARM_CUT` 이 그 자리다.
// ══════════════════════════════════════════════════════════════════
import { UNIT, PLAYER, ENEMY, NIGHT_SEC } from './config.js';

// 실제 40일 달력 키가 보스 배치의 정본이다. 다른 밤에는 보스/전조가 없다.
export const BOSS_NIGHT_MAP = Object.freeze({ N39: 'bear', N40: 'lion' });
export const bossKindForNight = (nightKey) => BOSS_NIGHT_MAP[nightKey] ?? null;

// 39·40밤 공통 — 보스 활성 중 물량층 스폰 −40%.
// 보스가 **걸어서** 다가갈 때 멈추는 자리 = 몸 + 소년 + 이 여유.
// 여유가 0이면 접촉 판정선과 같은 값이 되어 상시 피격이 된다(step() 주석 참조).
export const STANDOFF_PAD = 0.6 * UNIT;

export const BOSS_SWARM_CUT = 0.40;
export const bossSwarmMult = (active) => (active ? 1 - BOSS_SWARM_CUT : 1);

// 접촉 판정이 끝난 뒤 그림에 남기는 짧은 공격 구간. **판정 시간은 아니다.**
// 사자 시트의 웅크림→도약→앞발→회수 4칸이 60fps에서 읽히는 최소 길이와,
// 곰 시트의 앞발 충격→회수 2칸 길이를 각각 한 곳에 둔다.
export const BOSS_ATTACK_FX = Object.freeze({
  lion: Object.freeze({ kind: 'claw', duration: 0.48 }),
  bear: Object.freeze({ kind: 'impact', duration: 0.24 }),
});

// 10분짜리 시간형 생명력. 12칸·3페이즈를 보존하므로 한 칸은 정확히 50초다.
const BOSS_TICKS = 12;
const BOSS_PHASES = 3;
const BOSS_TICK_SEC = NIGHT_SEC / BOSS_TICKS;
export const BOSS_CLOCK = Object.freeze({
  TICK_SEC: BOSS_TICK_SEC,
  // 기존 외부 진단 코드 호환 별명. 값의 뜻은 이제 "1분"이 아니라 한 약화 칸이다.
  MINUTE_SEC: BOSS_TICK_SEC,
  LIFE_SEC: NIGHT_SEC,
  TICKS: BOSS_TICKS,
  PHASES: BOSS_PHASES,
  TICKS_PER_PHASE: BOSS_TICKS / BOSS_PHASES,
});

// 게이지가 찬 프레임의 다윗 좌표를 잠그고 그 좌표까지 실제 도약한다.
export const BOSS_ATTACKS = Object.freeze({
  bear: Object.freeze([
    Object.freeze({ kind: 'charge',  chargeSec: 8.0, leapSec: 0.72, recoverSec: 1.10, contact: 25 }),
    Object.freeze({ kind: 'maul',    chargeSec: 6.2, leapSec: 0.62, recoverSec: 0.86, contact: 30 }),
    Object.freeze({ kind: 'rampage', chargeSec: 4.6, leapSec: 0.52, recoverSec: 0.62, contact: 35 }),
  ]),
  lion: Object.freeze([
    Object.freeze({ kind: 'pounce', chargeSec: 7.0, leapSec: 0.58, recoverSec: 0.92, contact: 20 }),
    Object.freeze({ kind: 'rake',   chargeSec: 5.2, leapSec: 0.48, recoverSec: 0.70, contact: 25 }),
    Object.freeze({ kind: 'frenzy', chargeSec: 3.6, leapSec: 0.38, recoverSec: 0.50, contact: 30 }),
  ]),
});

export const BOSS_PHASE = Object.freeze({ PHASES: BOSS_CLOCK.PHASES });

export const BOSS = {
  bear: {
    ko: '곰', nights: ['N39'],
    // ── 정본 (명세 6-2 482행 · 30밤시트 428·461행) ──
    tell: 1.5,                    // 예고 = 앞발로 땅 긁기. **이것이 회피 신호다**
    dashDist: 12 * UNIT,          // 12유닛
    dashTime: 0.8,                // 0.8초  → 480px/초
    windowTime: 2.0,              // 정지 2초 = **급소 창**
    roam: [4, 6],                 // 배회 4~6초
    critMult: 3,                  // 배후에서 소년 무기 ×3
    win: 'survive',               // **살아남으면 쓰러진다.** 구 'kill'(잔존 시 실패)은 폐기
    contact: 25,                  // 명세 4장 105행 — 곰 접촉 25
    knock: true,                  // 명세 4장 106행 — 넉백은 하이에나·곰·사자만
    // ── 측정 대기 (명세 6-2 표) ──
    // **더 이상 측정 대기가 아니다.** 페이즈 시계가 반드시 0으로 데려가므로
    // 이 값은 「얼마나 빨리 끝낼 수 있는가」만 정한다(위 헤더 주석).
    hp: 4000, nonCritMult: 1, targetCycles: BOSS_CLOCK.PHASES,
    // ── 정본에 없음 — **임의값, 미검증.** 아래 주석 참조
    roamSpeed: ENEMY.elite.speed, // 배회 속도. 정예층 속도를 시작점으로 빌린다
    critArc: Math.PI,             // 배후 = 반구(180°). 각이 정본에 없다
    r: 2.5 * UNIT,                // 보이는 실루엣과 충돌을 함께 줄여 다윗 대비 체급을 맞춘다
  },
  lion: {
    ko: '사자', nights: ['N40'],
    // **피해 창이 없다 — 상시 유효타.** 계속 때리면서 도망 다닌다(카이팅).
    tell: 0, dashDist: 0, dashTime: 0, windowTime: 0, roam: [0, 0],
    critMult: 1,
    win: 'survive',               // 사자는 원래 이랬다 — 이제 셋이 같은 규칙이다
    contact: 20,                  // 명세 4장 105행 — 사자 접촉 20
    knock: true,
    hp: 3200, nonCritMult: 1, targetCycles: BOSS_CLOCK.PHASES,
    // 카이팅이 성립하려면 **소년보다 느려야** 하고(아니면 도망이 불가능),
    // 멈추면 맞아야 하므로 **충분히 빨라야** 한다. 그 사이 어딘가인데 정본에 없다.
    // → 소년 속도의 0.8배를 시작점으로 둔다. **임의값 — 미검증.**
    roamSpeed: PLAYER.speed * 0.8,
    critArc: 0,
    // **경보 = 사자 자신의 크기.** 예고가 아니라 조우가 경보다(명세 6-2 490행).
    // 크기는 아트 계약이므로 여기서는 반지름만 남긴다. 임의값 — 미검증.
    r: 2.5 * UNIT,
  },
};

// 공격 이름은 연출용 꼬리표가 아니라 잠금 순간 확정되는 기하의 종류다. 이 표를
// BossFSM 한 곳에서만 읽어 판정과 renderer가 서로 다른 공격을 그리지 않게 한다.
const BOSS_ATTACK_SHAPE = Object.freeze({
  charge: 'rush',
  maul: 'paw-pair',
  rampage: 'rush-chain',
  pounce: 'pounce-rake',
  rake: 'claw-pair',
  frenzy: 'bound-chain',
});

const clamp01 = (value) => Math.max(0, Math.min(1, Number(value) || 0));
const smoothstep = (value) => {
  const u = clamp01(value);
  return u * u * (3 - 2 * u);
};

const circleHitsSegment = (px, py, radius, segment) => {
  const abx = segment.bx - segment.ax, aby = segment.by - segment.ay;
  const denom = abx * abx + aby * aby;
  const u = denom > 0
    ? clamp01(((px - segment.ax) * abx + (py - segment.ay) * aby) / denom)
    : 0;
  const qx = segment.ax + abx * u, qy = segment.ay + aby * u;
  return Math.hypot(px - qx, py - qy) < radius;
};

const circleHitsDisc = (px, py, pr, disc) =>
  Math.hypot(px - disc.x, py - disc.y) < pr + disc.r;

const intervalTouches = (from, to, activeFrom = 0, activeTo = 1) =>
  Math.max(from, activeFrom) <= Math.min(to, activeTo) + 1e-9;

const componentActive = (component, progress) =>
  progress + 1e-9 >= (component.activeFrom ?? 0)
    && progress - 1e-9 <= (component.activeTo ?? 1);

const geometryBodyMoves = (shape) =>
  shape === 'rush' || shape === 'rush-chain'
    || shape === 'pounce-rake' || shape === 'bound-chain';

const geometryIsChain = (shape) => shape === 'rush-chain' || shape === 'bound-chain';

const geometryComponentsHit = (px, py, pr, geometry, progress = geometry.progress) => {
  if ((geometry.paws ?? []).some((paw) => componentActive(paw, progress)
      && circleHitsDisc(px, py, pr, paw))) return true;
  return (geometry.claws ?? []).some((claw) => componentActive(claw, progress)
    && circleHitsSegment(px, py, pr + claw.r, claw));
};

const sweptGeometryHits = (px, py, pr, sweep, bodyRadius) => {
  if ((sweep?.segments ?? []).some((segment) => circleHitsSegment(
    px, py, pr + bodyRadius, segment))) return true;
  if ((sweep?.paws ?? []).some((paw) => circleHitsDisc(px, py, pr, paw))) return true;
  return (sweep?.claws ?? []).some((claw) => circleHitsSegment(
    px, py, pr + claw.r, claw));
};

// 마법 도형 대신 실제 앞발이 닿는 두 지점을 만든다. `center`는 공격을 시작한
// 몸 중심이며, 곰은 몸을 세운 채 이 두 점으로 양앞발을 내려찍는다.
const makePawPair = (center, facing, bodyRadius, activeFrom, activeTo, pointIndex = 0) => {
  const side = { x: -facing.y, y: facing.x };
  const reach = bodyRadius * 0.92;
  const spread = bodyRadius * 0.58;
  const pawRadius = bodyRadius * 0.38;
  return [-1, 1].map((sign) => ({
    x: center.x + facing.x * reach + side.x * spread * sign,
    y: center.y + facing.y * reach + side.y * spread * sign,
    r: pawRadius,
    side: sign < 0 ? 'left' : 'right',
    pointIndex,
    activeFrom,
    activeTo,
  }));
};

// 사자의 갈퀴기는 채워진 부채꼴이 아니다. 양 어깨에서 시작해 앞쪽으로 교차하는
// 두 발톱 궤적만 실제 판정이며, renderer도 이 선분을 그대로 자세에 사용한다.
const makeClawPair = (center, facing, bodyRadius, activeFrom, activeTo, pointIndex = 0) => {
  const side = { x: -facing.y, y: facing.x };
  const baseForward = bodyRadius * 0.18;
  const tipForward = bodyRadius * 1.32;
  const baseSpread = bodyRadius * 0.52;
  const tipSpread = bodyRadius * 0.16;
  const clawRadius = bodyRadius * 0.16;
  return [-1, 1].map((sign) => ({
    ax: center.x + facing.x * baseForward + side.x * baseSpread * sign,
    ay: center.y + facing.y * baseForward + side.y * baseSpread * sign,
    bx: center.x + facing.x * tipForward - side.x * tipSpread * sign,
    by: center.y + facing.y * tipForward - side.y * tipSpread * sign,
    r: clawRadius,
    side: sign < 0 ? 'left' : 'right',
    pointIndex,
    activeFrom,
    activeTo,
  }));
};

const recordCount = (value) => Math.max(0, Math.floor(Number.isFinite(Number(value)) ? Number(value) : 0));
const recordAmount = (value) => Math.max(0, Number.isFinite(Number(value)) ? Number(value) : 0);

// A result-safe, non-mutating copy of the facts recorded during a boss night.
// World owns the player-side counters; the boss owns its phase/weak-point counters.
export function snapshotBossRecord(boss, counters = {}) {
  if (!boss?.kind) return null;
  const metrics = boss.m ?? {};
  const attackLocks = recordCount(metrics.attackLocks);
  const contactHits = recordCount(counters.hitsBoss);
  const record = {
    kind: boss.kind,
    cleared: boss.dead === true,
    attackLocks,
    bossHits: recordCount(counters.bossSwings),
    contactHits,
    avoided: Math.max(0, attackLocks - contactHits),
    pressureDamage: recordAmount(metrics.pressureDamage),
  };

  if (boss.kind === 'bear') {
    const windowSec = recordAmount(metrics.windowSec);
    const critWindowSec = Math.min(windowSec, recordAmount(metrics.critSec));
    record.critWindowSec = critWindowSec;
    record.critWindowRatio = windowSec > 0 ? critWindowSec / windowSec : 0;
  }
  return record;
}

// 상용 HUD가 보스 내부 필드를 제각각 해석하지 않도록, 화면에 공개할 사실을 한 번에
// 만든다. 시간 시계와 공격 게이지는 이미 BossFSM의 규칙값이며 이 함수는 표현만 맡는다.
export function bossHudState(boss) {
  if (!boss?.kind || !BOSS[boss.kind]) return null;
  const phase = Math.max(1, Math.min(BOSS_CLOCK.PHASES, recordCount(boss.phase) || 1));
  const fatigueTicks = Math.max(0, Math.min(BOSS_CLOCK.TICKS, recordCount(boss.minuteTick)));
  const attackRatio = Math.max(0, Math.min(1, recordAmount(boss.attackGauge)));
  const name = BOSS[boss.kind].ko;
  const action = boss.state === 'tell' ? '공격 준비 중'
    : boss.state === 'dash' ? '공격 중'
    : boss.state === 'window' ? '착지 회수 중'
      : `다음 공격 ${Math.round(attackRatio * 100)}%`;
  const hint = boss.kind === 'bear'
    ? (boss.state === 'window'
      ? '지금 배후 급소 ×3 · 타격하면 다음 도약이 늦어진다'
      : '착지 회수 중 배후 급소 ×3 · 타격하면 다음 도약이 늦어진다')
    : '계속 이동해 피하기 · 타격하면 다음 도약이 늦어진다';
  return Object.freeze({
    name,
    phase,
    phases: BOSS_CLOCK.PHASES,
    fatigueTicks,
    fatigueTotal: BOSS_CLOCK.TICKS,
    fatigueRatio: fatigueTicks / BOSS_CLOCK.TICKS,
    attackRatio,
    title: `${name} · 단계 ${phase}/${BOSS_CLOCK.PHASES} · 시간 약화 ${fatigueTicks}/${BOSS_CLOCK.TICKS} (${BOSS_CLOCK.TICK_SEC}초마다 1칸)`,
    meta: `${action} · ${hint}`,
  });
}

export function makeBoss(kind, opts = {}) { return new BossFSM(kind, opts); }

export class BossFSM {
  // opts: { x, y, rnd, onCue, hp }   rnd = 결정적 난수(월드의 것을 넘겨 준다)
  constructor(kind, opts = {}) {
    this.kind = kind;
    this.cfg = { ...BOSS[kind], ...(opts.cfg ?? {}) };
    this.rnd = opts.rnd ?? Math.random;
    this.onCue = opts.onCue ?? (() => {});     // 사운드 큐 발화 — 14 곰 땅 긁기
    this.x = opts.x ?? 0; this.y = opts.y ?? 0;
    this.fx = 1; this.fy = 0;                  // 바라보는 방향 = 배후 판정의 기준
    this.hp = opts.hp ?? this.cfg.hp;
    this.maxHp = this.hp;
    this.hpMax = this.maxHp;                   // HUD 공개 계약(alias)
    this.dead = false;
    this.t = 0;
    // 기본 추적 상태는 기존 렌더 키를 유지한다.
    this.state = kind === 'lion' ? 'active' : 'roam';
    this.stateT = 0;
    // Renderer-facing locomotion signals. `moving` describes only grounded
    // pursuit; the locked leap has its own authored attack frames. Distance,
    // rather than wall-clock time, keeps footfalls in sync with phase speed.
    this.moving = false;
    this.walkDistance = 0;
    this.m = { cycles: 0, windows: 0, windowSec: 0, critSec: 0, dashes: 0,
               phaseAt: [], attackLocks: 0, hpTicks: 0, pressureDamage: 0 };
    // ── 렌더용 공격 펄스 ────────────────────────────────────────
    // 상태(state)는 판정의 정본이고, 이 세 필드는 그 상태/접촉을 그림에 전달하는
    // 읽기 전용 신호다. 사자는 상태가 `active` 하나뿐이라 접촉이 일어나도 기존에는
    // 렌더가 알 길이 없었다. 피해·무적·이동은 이 값을 한 번도 읽지 않는다.
    this.attackKind = null;
    this.attackAge = Infinity;
    this.attackDuration = 0;
    this.attackSeq = 0;                     // 같은 종류의 연속 공격도 구분하는 번호
    this.attackGauge = 0;                  // HUD 공개 계약: 0..1
    this.target = null;                    // { x, y, lockedAt, seq }
    this.contactSpent = false;             // 공격 seq당 접촉 피해는 정확히 한 번
    // 판정·VFX 공용 계약. 잠금 시 한 번 만들고 commit 동안 수치만 갱신한다.
    // `points`까지 잠금 순간 확정되므로 이후 다윗 좌표를 다시 읽지 않는다.
    this.attackGeometry = null;
    this._leapFrom = null;
    this._leapTo = null;
    this._leapElapsed = 0;
    this._leapDuration = 0;
    this._hopIndex = 0;
    // World가 step 뒤 한 번 판정을 묻는 동안, 이번 step에서 commit이 지나간
    // 연속 영역을 보존한다. 프레임이 커져도 충격파/갈퀴/도약을 건너뛰지 않는다.
    this._contactSweep = null;

    // ── 10분 / 3페이즈 시계 ───────────────────────────────────
    this.lifeSec = opts.lifeSec ?? BOSS_CLOCK.LIFE_SEC;
    this.phase = 1;                        // HUD 공개 계약: 1..3
    this.phaseT = 0;
    this.minuteTick = 0;                   // 이미 적용된 50초 HP tick 수(필드명은 저장 호환)
    this.nextHpTickSec = BOSS_CLOCK.TICK_SEC;
    this.pressureDamage = 0;               // 무기 피해는 HP 대신 공격 게이지를 늦춘다
  }

  // 이번 페이즈에 배정된 시간. 균등 분할이다.
  get phaseLen() { return this.lifeSec / BOSS_CLOCK.PHASES; }
  get phaseProgress() { return Math.max(0, Math.min(1, this.phaseT / this.phaseLen)); }
  get minuteProgress() {
    const since = this.t - this.minuteTick * BOSS_CLOCK.TICK_SEC;
    return Math.max(0, Math.min(1, since / BOSS_CLOCK.TICK_SEC));
  }
  get attackPattern() { return BOSS_ATTACKS[this.kind][Math.max(0, this.phase - 1)]; }
  // 사자는 leapSec만큼 낮게 몸을 접은 뒤 같은 길이로 실제 도약/앞발 동작을 한다.
  // 곰은 기존 1.5초 앞발 긁기 예고를 세 물리 공격 모두 공유한다.
  attackSignalSec(spec = this._attackSpec ?? this.attackPattern) {
    return this.kind === 'bear' ? this.cfg.tell : spec.leapSec;
  }
  get contactDamage() { return (this._attackSpec ?? this.attackPattern).contact; }
  get canContactDamage() {
    if (this.contactSpent) return false;
    if (this._contactSweep) return true;
    return !!this.target && this.state === 'dash'
      && (this.attackGeometry?.active ?? true);
  }
  consumeContact() {
    if (!this.canContactDamage) return false;
    this.contactSpent = true;
    this._contactSweep = null;
    if (this.attackGeometry) this.attackGeometry.active = false;
    return true;
  }

  get standoffRange() {
    return (this.cfg.r ?? 2 * UNIT) + PLAYER.r + STANDOFF_PAD;
  }

  /**
   * 잠금 공격의 판정 정본. World는 보스 몸 원을 별도로 추측하지 않고 이 메서드를
   * 호출하며, renderer는 같은 `attackGeometry`를 그린다. `pr`은 다윗 몸 반지름이다.
   */
  contactGeometryHits(px, py, pr = PLAYER.r) {
    if (!this.canContactDamage) return false;
    const sweep = this._contactSweep;
    if (sweep && sweptGeometryHits(px, py, pr, sweep, this.cfg.r ?? 0)) return true;

    const g = this.attackGeometry;
    if (!g?.active) return false;
    if (geometryBodyMoves(g.shape)
        && Math.hypot(px - this.x, py - this.y) < (this.cfg.r ?? 0) + pr) return true;
    return geometryComponentsHit(px, py, pr, g);
  }

  // 50초 tick과 200초 페이즈 경계를 한 절대 시계에서 계산한다.
  syncClock(elapsed) {
    if (this.dead || this.hp == null) return;
    const clock = Math.max(this.t, Math.min(this.lifeSec, Number(elapsed) || 0));
    this.t = clock;

    const wantedTicks = Math.min(BOSS_CLOCK.TICKS,
      Math.floor((clock + 1e-9) / BOSS_CLOCK.TICK_SEC));
    while (this.minuteTick < wantedTicks) {
      this.minuteTick++;
      this.hp = Math.max(0, this.maxHp * (1 - this.minuteTick / BOSS_CLOCK.TICKS));
      this.m.hpTicks = this.minuteTick;
      this.onCue({ c: 'boss-hp-tick', tick: this.minuteTick, hp: this.hp });
    }
    this.nextHpTickSec = this.minuteTick >= BOSS_CLOCK.TICKS
      ? this.lifeSec : (this.minuteTick + 1) * BOSS_CLOCK.TICK_SEC;

    const nextPhase = Math.min(BOSS_CLOCK.PHASES,
      1 + Math.floor(Math.min(clock, this.lifeSec - 1e-9) / this.phaseLen));
    if (nextPhase !== this.phase) {
      this.phase = nextPhase;
      this.m.phaseAt.push(clock);
      this.onCue({ c: 'boss-phase', phase: this.phase });
    }
    this.phaseT = Math.min(this.phaseLen, clock - (this.phase - 1) * this.phaseLen);

    if (this.minuteTick >= BOSS_CLOCK.TICKS) {
      this.hp = 0;
      this.dead = true;
      this.byTime = true;
      this.moving = false;
      this.attackGauge = 0;
      this.target = null;
      this.attackGeometry = null;
      this._contactSweep = null;
    }
  }

  get windowOpen() { return this.state === 'window'; }
  // 카이팅 보스에는 급소 창이 없다 — 그래서 *"상시 유효타"* 다.
  get alwaysVulnerable() { return this.kind === 'lion'; }
  get attackActive() { return this.attackAge < this.attackDuration; }
  get attackProgress() {
    if (!this.attackActive) return 1;
    return Math.max(0, Math.min(1, this.attackAge / Math.max(this.attackDuration, 1e-6)));
  }

  // 도약/착지/접촉의 렌더 펄스. 판정 자체는 target과 contact latch가 맡는다.
  beginAttack(kind, duration) {
    this.attackKind = kind;
    this.attackAge = 0;
    this.attackDuration = Math.max(1 / 60, Number(duration) || 0);
    this.attackSeq++;
  }

  advanceAttackPulse(dt) {
    if (!this.attackActive) return;
    this.attackAge = Math.min(this.attackDuration, this.attackAge + Math.max(0, dt));
  }

  makeLockedGeometry(spec, px, py) {
    const origin = { x: this.x, y: this.y };
    const facing = { x: this.fx, y: this.fy };
    const shape = BOSS_ATTACK_SHAPE[spec.kind] ?? 'point';
    const hopCount = geometryIsChain(shape) ? BOSS_CLOCK.PHASES : 1;
    const points = [origin];
    let range = Math.hypot(px - origin.x, py - origin.y);
    const bodyRadius = Math.max(1, this.cfg.r ?? 0);
    const paws = [];
    const claws = [];
    const strikes = [];

    if (shape === 'rush' || shape === 'pounce-rake') {
      points.push({ x: px, y: py });
      if (shape === 'pounce-rake') {
        const landingFrom = 0.72, landingTo = 1;
        claws.push(...makeClawPair(points[1], facing, bodyRadius,
          landingFrom, landingTo, 1));
        strikes.push({ kind: 'claws', pointIndex: 1,
          activeFrom: landingFrom, activeTo: landingTo });
      }
    } else if (geometryIsChain(shape)) {
      // 곰은 12유닛을 세 번의 지상 돌진으로 나누고 매 종점에 양앞발을 내린다.
      // 사자는 정지거리 한 보폭을 세 번 연속으로 뛰며 각 착지에 앞발을 회수한다.
      const totalReach = spec.kind === 'rampage'
        ? this.cfg.dashDist
        : this.standoffRange * hopCount;
      range = totalReach;
      const stride = totalReach / hopCount;
      for (let i = 1; i <= hopCount; i++) {
        points.push({
          x: origin.x + facing.x * stride * i,
          y: origin.y + facing.y * stride * i,
        });
        const activeFrom = Math.max(0, (i - 0.24) / hopCount);
        const activeTo = i / hopCount;
        if (shape === 'rush-chain') {
          paws.push(...makePawPair(points[i], facing, bodyRadius,
            activeFrom, activeTo, i));
          strikes.push({ kind: 'paws', pointIndex: i, activeFrom, activeTo });
        } else {
          claws.push(...makeClawPair(points[i], facing, bodyRadius,
            activeFrom, activeTo, i));
          strikes.push({ kind: 'claws', pointIndex: i, activeFrom, activeTo });
        }
      }
    } else if (shape === 'paw-pair') {
      range = bodyRadius * 1.5;
      const activeFrom = 0.42, activeTo = 0.72;
      paws.push(...makePawPair(origin, facing, bodyRadius,
        activeFrom, activeTo, 0));
      strikes.push({ kind: 'paws', pointIndex: 0, activeFrom, activeTo });
    } else if (shape === 'claw-pair') {
      range = bodyRadius * 1.5;
      const activeFrom = 0.30, activeTo = 0.78;
      claws.push(...makeClawPair(origin, facing, bodyRadius,
        activeFrom, activeTo, 0));
      strikes.push({ kind: 'claws', pointIndex: 0, activeFrom, activeTo });
    } else {
      points.push({ x: px, y: py });
    }

    return {
      seq: this.attackSeq + 1,
      kind: spec.kind,
      shape,
      stage: 'signal',
      origin,
      facing,
      points,
      range,
      bodyRadius,
      paws,
      claws,
      strikes,
      hopIndex: 0,
      hopCount,
      progress: 0,
      active: false,
    };
  }

  updateAttackGeometry(stage, progress, active) {
    const g = this.attackGeometry;
    if (!g) return;
    g.stage = stage;
    g.progress = clamp01(progress);
    const bodyActive = geometryBodyMoves(g.shape);
    const limbActive = [...(g.paws ?? []), ...(g.claws ?? [])]
      .some((part) => componentActive(part, g.progress));
    g.active = !!active && !this.contactSpent && (bodyActive || limbActive);
    g.hopIndex = this._hopIndex;
  }

  extendContactSweep(g, before) {
    if (this.contactSpent || !g) return;
    let sweep = this._contactSweep;
    if (!sweep || sweep.shape !== g.shape) {
      sweep = {
        shape: g.shape,
        origin: { ...g.origin },
        facing: { ...g.facing },
        range: g.range,
        segments: [],
        paws: [],
        claws: [],
      };
      this._contactSweep = sweep;
    }
    if (geometryBodyMoves(g.shape)) {
      sweep.segments.push({ ax: before.x, ay: before.y, bx: this.x, by: this.y });
    }
    const from = Math.min(before.progress ?? g.progress, g.progress);
    const to = Math.max(before.progress ?? g.progress, g.progress);
    for (const paw of g.paws ?? []) {
      if (intervalTouches(from, to, paw.activeFrom, paw.activeTo)
          && !sweep.paws.includes(paw)) sweep.paws.push(paw);
    }
    for (const claw of g.claws ?? []) {
      if (intervalTouches(from, to, claw.activeFrom, claw.activeTo)
          && !sweep.claws.includes(claw)) sweep.claws.push(claw);
    }
  }

  beginLockedDash() {
    const spec = this._attackSpec ?? this.attackPattern;
    if (!this.attackGeometry) {
      const target = this.target ?? { x: this.x, y: this.y };
      this.attackGeometry = this.makeLockedGeometry(spec, target.x, target.y);
    }
    const g = this.attackGeometry;
    this.state = 'dash';
    this._hopIndex = 0;
    this._leapFrom = { x: g.points[0].x, y: g.points[0].y };
    this._leapTo = !geometryBodyMoves(g.shape)
      ? { ...this._leapFrom }
      : { x: g.points[1].x, y: g.points[1].y };
    this._leapElapsed = 0;
    this._leapDuration = spec.leapSec;
    const commitSec = spec.leapSec * g.hopCount;
    this.stateT = commitSec;
    this.m.dashes++;
    this.updateAttackGeometry('commit', 0, true);
    this.beginAttack(spec.kind, commitSec);
  }

  finishLockedCommit() {
    const spec = this._attackSpec ?? this.attackPattern;
    const g = this.attackGeometry;
    this.state = 'window';
    this.stateT = spec.recoverSec;
    this.m.windows++;
    // 모든 보스의 회수는 안전한 반격 창이다. commit을 건너뛴 큰 프레임은 직전
    // `_contactSweep`만 한 번 질의할 수 있고, 다음 step부터 몸 겹침도 피해가 없다.
    this.updateAttackGeometry('recovery', 1, false);
    const landingFx = BOSS_ATTACK_FX[this.kind];
    this.beginAttack(landingFx.kind, landingFx.duration);
  }

  advanceLockedCommit(dt) {
    let left = Math.max(0, dt);
    let used = 0;
    const spec = this._attackSpec ?? this.attackPattern;
    const g = this.attackGeometry;
    if (!g) return 0;

    while (left > 1e-9 && this.state === 'dash') {
      const before = {
        x: this.x,
        y: this.y,
        progress: g.progress,
      };
      const slice = Math.min(left, this._leapDuration - this._leapElapsed);
      this._leapElapsed += slice;
      left -= slice;
      used += slice;
      this.advanceAttackPulse(slice);
      const local = clamp01(this._leapElapsed / Math.max(this._leapDuration, 1e-9));
      const overall = (this._hopIndex + local) / g.hopCount;
      const u = smoothstep(local);

      if (geometryBodyMoves(g.shape)) {
        this.x = this._leapFrom.x + (this._leapTo.x - this._leapFrom.x) * u;
        this.y = this._leapFrom.y + (this._leapTo.y - this._leapFrom.y) * u;
      } else {
        // 양앞발 내려찍기/제자리 갈퀴기는 몸이 origin에 남고 실제 팔다리만 움직인다.
        this.x = g.origin.x;
        this.y = g.origin.y;
      }
      this.stateT = Math.max(0,
        (g.hopCount - this._hopIndex - 1) * spec.leapSec
          + this._leapDuration - this._leapElapsed);
      this.updateAttackGeometry('commit', overall, true);
      this.extendContactSweep(g, before);

      if (local < 1) break;
      this.x = this._leapTo.x;
      this.y = this._leapTo.y;
      if (geometryIsChain(g.shape) && this._hopIndex + 1 < g.hopCount) {
        this._hopIndex++;
        this._leapFrom = { x: this.x, y: this.y };
        this._leapTo = {
          x: g.points[this._hopIndex + 1].x,
          y: g.points[this._hopIndex + 1].y,
        };
        this._leapElapsed = 0;
        this._leapDuration = spec.leapSec;
        this.updateAttackGeometry('commit', this._hopIndex / g.hopCount, true);
        continue;
      }
      this.finishLockedCommit();
    }
    return used;
  }

  // 배후 판정 — **위치다, 조준이 아니다.** 바라보는 방향의 반대 반구에 서 있으면 급소.
  isBehind(px, py) {
    const dx = px - this.x, dy = py - this.y, d = Math.hypot(dx, dy) || 1;
    const dot = (dx / d) * this.fx + (dy / d) * this.fy;
    return dot < Math.cos(Math.PI - this.cfg.critArc / 2);
  }
  // 지금 이 위치에서 때리면 배율이 얼마인가.
  //   급소  → critMult(곰 ×3)
  //   비급소 → cfg.nonCritMult. **null 이면 「측정 대기」다** — 호출부가 그걸 알아야 한다.
  damageMult(px, py) {
    if (this.alwaysVulnerable) return this.cfg.nonCritMult;   // 사자는 창이 없다(상시 유효타)
    if (this.windowOpen && this.isBehind(px, py)) return this.cfg.critMult;
    return this.cfg.nonCritMult;
  }

  hit(dmg) {
    if (this.hp == null) return false;
    const dealt = Math.max(0, Number(dmg) || 0);
    this.pressureDamage += dealt;
    this.m.pressureDamage += dealt;
    // 시간형 HP는 플레이어 DPS에 흔들리지 않는다. 대신 공격을 적중시키면 다음 도약
    // 게이지를 밀어내므로 무기의 의미는 생존 공간을 버는 것으로 남는다.
    if (this.state === 'roam' || this.state === 'active') {
      this.attackGauge = Math.max(0, this.attackGauge - dealt / (this.maxHp * 0.30));
    }
    return false;
  }

  lockAttackTarget(px, py) {
    const spec = this.attackPattern;
    const dx = px - this.x, dy = py - this.y, d = Math.hypot(dx, dy) || 1;
    this.fx = dx / d; this.fy = dy / d;
    this._attackSpec = spec;
    this.target = { x: px, y: py, lockedAt: this.t, seq: this.attackSeq + 1 };
    this.attackGeometry = this.makeLockedGeometry(spec, px, py);
    this._contactSweep = null;
    this.contactSpent = false;
    this.attackGauge = 1;
    this.moving = false;
    this.m.attackLocks++;
    this.onCue({ c: 'boss-lock', kind: spec.kind, phase: this.phase,
                 target: { x: px, y: py } });
    const signalSec = this.attackSignalSec(spec);
    if (signalSec > 0) {
      // 좌표는 게이지가 찬 이 순간 한 번만 잠근다. 곰은 앞발로 땅을 긁고 몸을
      // 세우며, 사자는 낮게 웅크린다. 신호 중에는 어떤 신체 접촉 판정도 없다.
      this.state = 'tell';
      this.stateT = signalSec;
      this.attackKind = spec.kind;
      this.attackAge = Infinity;
      this.attackDuration = 0;
      this.updateAttackGeometry('signal', 0, false);
      if (this.kind === 'bear') this.onCue('bearDig');
      return;
    }
    this.beginLockedDash();
  }

  // 게이지 → 기하 잠금 → commit → 회수. 큰 dt도 남은 시간을 다음 상태로 넘겨
  // 60fps 조각 실행과 같은 상태/좌표에 도달한다.
  step(dt, ctx = {}) {
    if (this.dead) return this.state;
    this.moving = false;
    dt = Math.max(0, Number(dt) || 0);
    // 직전 step의 질의 창은 World.stepBoss에서 이미 소비됐다. 이번 step이 실제로
    // 지나간 commit 영역만 새로 모은다. dt=0이면 현재 active 기하가 그대로 판정된다.
    this._contactSweep = null;
    this.syncClock(ctx.elapsed ?? (this.t + dt));
    if (this.dead) return this.state;

    const px = ctx.px ?? this.x, py = ctx.py ?? this.y;
    const baseState = this.kind === 'lion' ? 'active' : 'roam';
    const face = () => {
      const dx = px - this.x, dy = py - this.y, d = Math.hypot(dx, dy) || 1;
      this.fx = dx / d; this.fy = dy / d;
    };
    let left = dt;
    while (left > 1e-9 || (this.state === baseState && this.attackGauge >= 1)) {
      if (this.state === baseState) {
        const spec = this.attackPattern;
        const toLock = Math.max(0, (1 - this.attackGauge) * spec.chargeSec);
        const slice = Math.min(left, toLock);
        face();
        const gap = Math.hypot(px - this.x, py - this.y) - this.standoffRange;
        if (gap > 0 && slice > 0) {
          const phaseSpeed = 1 + (this.phase - 1) * 0.12;
          const move = Math.min(this.cfg.roamSpeed * phaseSpeed * slice, gap);
          this.x += this.fx * move;
          this.y += this.fy * move;
          if (move > 1e-4) {
            this.moving = true;
            this.walkDistance += move;
          }
        }
        this.attackGauge = Math.min(1, this.attackGauge + slice / spec.chargeSec);
        this.advanceAttackPulse(slice);
        left -= slice;
        if (this.attackGauge >= 1) {
          this.attackGauge = 1;
          this.lockAttackTarget(px, py);
          continue;
        }
        break;
      }

      if (this.state === 'tell') {
        const signalSec = this.attackSignalSec();
        const slice = Math.min(left, this.stateT);
        this.stateT = Math.max(0, this.stateT - slice);
        this.advanceAttackPulse(slice);
        left -= slice;
        this.updateAttackGeometry('signal', 1 - this.stateT / Math.max(signalSec, 1e-9), false);
        if (this.stateT <= 0) {
          this.beginLockedDash();
          continue;
        }
        break;
      }

      if (this.state === 'dash') {
        const used = this.advanceLockedCommit(left);
        left -= used;
        if (this.state !== 'dash') continue;
        break;
      }

      if (this.state === 'window') {
        const slice = Math.min(left, this.stateT);
        this.stateT = Math.max(0, this.stateT - slice);
        this.m.windowSec += slice;
        if (this.isBehind(px, py)) this.m.critSec += slice;
        this.advanceAttackPulse(slice);
        left -= slice;
        if (this.stateT <= 0) {
          this.state = baseState;
          this.attackGauge = 0;
          this.target = null;
          this._attackSpec = null;
          this.attackGeometry = null;
          this._leapFrom = null;
          this._leapTo = null;
          this.m.cycles++;
          continue;
        }
        break;
      }

      break;
    }
    return this.state;
  }

  // 밤이 끝났을 때의 판정 (명세 6-2 전역 계약 467행)
  //   HP 0 = 격퇴(승리) · 시간 도달 시 잔존 = 그 밤 실패 → 재시도
  //   N29만 예외 — 밤 끝까지 생존도 성립
  outcome(t = this.t) {
    if (this.dead) return '격퇴';
    if (t < NIGHT_SEC) return '진행중';
    // ⚠ **구 구현은 여기서 `'kill-or-survive'` 를 찾았다.** 그런데 셋 다
    //   `win: 'survive'` 로 바뀐 뒤(사장님 결정 2026-07-28) 그 문자열은
    //   **어느 cfg 에도 없다** — 그래서 밤 끝까지 버텨도 세 보스 전부 「실패」였다.
    //   정본: *"살아서 밤을 마치면 보스는 반드시 쓰러진다 … 「보스를 못 죽여서
    //   실패한 밤」이라는 것이 이제 없다. 실패는 다운뿐이다."*
    return this.cfg.win === 'kill' ? '실패' : '생존';
  }

  report() {
    const c = this.cfg;
    return {
      보스: `${c.ko}(${this.kind})`,
      상태: this.state,
      HP: this.hp == null ? '측정 대기' : `${Math.max(0, this.hp | 0)} / ${this.maxHp}`,
      페이즈: `${this.phase} / ${BOSS_CLOCK.PHASES}`,
      '시간 약화 HP': `${this.minuteTick} / ${BOSS_CLOCK.TICKS} tick`,
      '공격 게이지': `${(this.attackGauge * 100).toFixed(0)}%`,
      '공격 종류': this.attackKind ?? '-',
      '잠금 목표': this.target ? `${this.target.x.toFixed(1)}, ${this.target.y.toFixed(1)}` : '-',
      '비급소 배율': c.nonCritMult == null ? '측정 대기' : `×${c.nonCritMult}`,
      '급소 배율': this.alwaysVulnerable ? '해당 없음(상시 유효타)' : `×${c.critMult}`,
      '사이클': `${this.m.cycles}회 · 돌진 ${this.m.dashes} · 급소 창 ${this.m.windows}`,
      '급소 창 점유': this.m.windowSec > 0
        ? `${(this.m.critSec / this.m.windowSec * 100).toFixed(0)}% (창 ${this.m.windowSec.toFixed(1)}초 중 배후 ${this.m.critSec.toFixed(1)}초)`
        : '-',
      '공격 잠금': `${this.m.attackLocks}회`,
      결과: this.outcome(),
    };
  }
}
